module.exports = __webpack_public_path__ + "assets/images/USDNEW5.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/USDNEW5.png
// module id = 1463
// module chunks = 1